module.exports = __webpack_public_path__ + "img/user-icon2.0ca57f2d.png";